import axiosService from "@/modules/axios-service";

async function handleOAuth(obj) {
    
}

function exportHash(hash) {
  const params = new URLSearchParams(hash.substring(1));
  let resultRaw = "{";
  for (var pair of params.entries()) {
    resultRaw += '"' + pair[0] + '":"' + pair[1] + '",';
  }
  resultRaw = resultRaw.slice(0, -1) + "}";

  return JSON.parse(resultRaw);
}

export { handleOAuth };
